import {
  Box,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import React from "react";
import { PanoramaVm } from "../../../data/k-projects/c4.data";
import { spaceModeVm } from "../../../data/models/space-mode.data";
import { DownArrow } from "../../../icons";
import useCommonDataStore from "../../../stores/common.store";
import useViewStore from "../../../stores/viewer.store";
import PanoramaPopup from "../../PanoramaPopup";
import useApplyViewModel from "../useApplyViewModel";
import usePanoramaPins from "../usePanoramaPins";
import useC4Boundary from "./useC4Boundary";

type TC4Version = "성수클러스터_2차" | "성수클러스터_4차";

const backgroundStyle = {
  borderRadius: "5px",
  border: "solid 1px white",
  marginBottom: "8px",
};

const prefix = "c4site";

export default function C4SiteMenuBtn() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [c4Version, setC4Version] =
    React.useState<TC4Version>("성수클러스터_2차");
  const { commonData, setCommonData } = useCommonDataStore();

  const toggleDropdown = () => {
    setCommonData({
      ...commonData,
      isActive: !isOpen ? prefix : "",
      slider: false,
    });
    setIsOpen(!isOpen);
  };

  React.useEffect(() => {
    const { isActive } = commonData;
    if (isActive !== prefix) setIsOpen(false);
  }, [commonData]);

  const { init, clear } = usePanoramaPins({
    prefix: prefix!,
    vm: PanoramaVm,
    show: isOpen,
    zRatio: 20,
  });

  const selectedItem = spaceModeVm.items.find((i) => i.name === c4Version);

  useApplyViewModel({
    show: isOpen,
    modelPath: selectedItem?.modelPath,
  });

  const { setPhase } = useViewStore();
  React.useEffect(() => {
    if (isOpen) {
      setPhase(selectedItem?.phase ?? PanoramaVm.phase);
    }
  }, [setPhase, isOpen, selectedItem]);

  useC4Boundary({ show: isOpen });

  return (
    <Box sx={backgroundStyle}>
      <PanoramaPopup
        clear={clear}
        init={init}
        prefix={prefix}
        show={isOpen}
        vm={PanoramaVm}
      />
      <Button
        sx={{
          padding: "0px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          color: isOpen ? "yellow" : "white",
        }}
        onClick={toggleDropdown}
      >
        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Typography
            sx={{
              size: "14px",
              lineHeight: "22px",
              letterSpacing: "-0.43px",
              fontWeight: "700",
            }}
          >
            C4 RFP
          </Typography>
          <DownArrow
            sx={{ marginLeft: "auto", width: "30px", height: "30px" }}
          />
        </Box>
        <Typography sx={{ fontSize: "10px" }}> 2025.03 </Typography>
      </Button>
      {isOpen && (
        <Box sx={{ padding: "8px 12px" }}>
          <ToggleButtonGroup
            exclusive
            size="small"
            sx={{
              "& .Mui-selected": {
                color: "yellow !important",
              },
              "& .MuiToggleButton-root": {
                borderColor: "white",
                color: "white",
                flex: 1,
                fontSize: "10px",
                padding: "2px 8px",
              },
              width: "100%",
            }}
            value={c4Version}
            onChange={(_, value: TC4Version | null) => {
              if (value) setC4Version(value);
            }}
          >
            <ToggleButton value="성수클러스터_2차">2차</ToggleButton>
            <ToggleButton value="성수클러스터_4차">4차</ToggleButton>
          </ToggleButtonGroup>
        </Box>
      )}
    </Box>
  );
}
